import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { FileItem, FileItemFileTyped } from '../../models';
import { cuePanorama, cuePlayFill, IconComponent } from '@cue/ui/icons';
import { ImageComponent } from '@cue/images';
import { TranslocoPipe } from '@jsverse/transloco';
import { translation } from '@cue/translations';
import { NgClass } from '@angular/common';
import { GalleryComponent } from '@cue/ui/gallery';

@Component({
  selector: 'cue-file-gallery',
  imports: [IconComponent, ImageComponent, TranslocoPipe, NgClass, GalleryComponent],
  templateUrl: './file-gallery.component.html',
  styleUrl: './file-gallery.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileGalleryComponent {
  ICONS = {
    cuePanorama,
    cuePlayFill,
  };

  files = input<FileItem[]>([]);
  hasAnyFile = computed(() => (this.files() ?? []).length > 0);
  // hasMoreFiles = computed(() => (this.files() ?? []).length > 1);
  selectedFile = signal<FileItem | null>(null);

  computedFiles = computed(() => {
    return (this.files() ?? []).map((file) => {
      return {
        uniqueIdentifier: file.matterportUrl ?? file.imageUrl ?? file.file,
        originalFile: file,
        type: file.type,
        isImage: file.type === FileItemFileTyped.Image,
        isVideo: file.type === FileItemFileTyped.Video,
        isMatterport: file.type === FileItemFileTyped.Matterport,
        src: file.imageUrl ?? file.file,
        matterportUrl: file.matterportUrl,
        containerClass: {
          ring: this.selectedFile() === file || (!this.selectedFile() && (this.files() ?? [])[0] === file),
        },
        imagePreferCover: file.imagePreferCover,
        imageObjectPosition: file.imageObjectPosition ?? '50% 50%',
        imageClass: {
          'type-image': file.type === FileItemFileTyped.Image,
          'type-video': file.type === FileItemFileTyped.Video,
          'type-matterport': file.type === FileItemFileTyped.Matterport,
          'img-cover': file.imagePreferCover,
        },
      };
    });
  });

  computedSelectedFile = computed(() => {
    if (this.selectedFile()) {
      return this.computedFiles().find((file) => file.originalFile === this.selectedFile());
    }
    return null;
  });

  protected readonly translation = translation;

  onOpenedChanges($event: any) {
    if (!$event) {
      this.selectedFile.set(null);
    } else {
      const file = this.computedFiles().find((f) => f.uniqueIdentifier === $event?.uniqueIdentifier);
      if (file) {
        this.selectedFile.set(file.originalFile);
      }
    }
  }
}
